export default __webpack_public_path__ + "e098bee595231f8a3c59f923d1035939.svg";